import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { Switch, Input, Modal } from 'antd';
import { IMAGE_BASE_URL_OF_USER } from '../../../constants';

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedStaff: any;
  setSelectedStaff: React.Dispatch<React.SetStateAction<object>>;
  setOpenModalDeleteImage: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ModalViewImage({
  open,
  setOpen,
  selectedStaff,
  setSelectedStaff,
  setOpenModalDeleteImage,
}: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      centered
      visible={open}
      onOk={() => setOpen(false)}
      onCancel={() => setOpen(false)}
      className="modal_review_img"
    >
      <div className="flex flex-col">
        <div className="flex h-[56px] px-4 justify-between items-center">
          <span className="text-[#1D2939] text-[20px] notosans_bold">
            {selectedStaff?.nick_name || ' - '}
          </span>
          <button
            onClick={() => {
              setSelectedStaff({});
              setOpen(false);
            }}
            className="text-base text-primary notosans_medium"
          >
            {t('CLOSE')}
          </button>
        </div>
        <div className="flex justify-center items-center p-4">
          <img
            className="h-[468px] w-[468px] rounded-[8px]"
            src={
              selectedStaff && selectedStaff?.imageUrl
                ? // &&
                  // Object.keys(selectedStaff?.image_app_pos_ranking).length > 0
                  selectedStaff?.imageUrl
                : `${
                    IMAGE_BASE_URL_OF_USER +
                    '/avatar_ranking_user_shop' +
                    '/' +
                    selectedStaff.avatar_ranking
                  }?ts=${Date.now()}`
            }
          />
        </div>
        <div className="grid grid-cols-2 gap-[8px] p-[12px] border-t border-solid border-[#D0D5DD]">
          <button
            onClick={() => {
              setSelectedStaff({});
              setOpen(false);
            }}
            className="border border-solid border-[#D5D7DA] rounded-[6px] h-[44px] flex items-center justify-center text-[16px] notosans_medium text-[#666687]"
          >
            {t('CANCEL')}
          </button>
          <button
            onClick={() => {
              setOpen(false);
              setTimeout(() => {
                setOpenModalDeleteImage(true);
              }, 100);
            }}
            className="border border-solid border-[#F04438] rounded-[6px] h-[44px] flex items-center justify-center"
          >
            <span>{cts.deleteIcon}</span>
            <span className="ml-[8px] text-[16px] text-[#F04438] notosans_medium">
              {t('DELETE')}
            </span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
